import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

export const TitlesViewContext = createContext();

export const TitlesViewContextProvider = ({ children }) => {
  const [titlesView, setTitlesView] = useState('table');

  return (
    <TitlesViewContext.Provider
      value={{
        titlesView,
        setTitlesView,
      }}
    >
      {children}
    </TitlesViewContext.Provider>
  );
};

TitlesViewContextProvider.propTypes = {
  children: PropTypes.element,
};
